import React, { ReactNode } from 'react';
import css from './index.module.scss';
import { Footer } from './Footer';
import { Header } from './Header';
import { SEO } from './Seo';
import {
  SectionTracker,
  SectionTrackerProps,
} from '../SectionTracker';
import { SectionContextProvider } from '../../context';

interface LayoutProps extends SectionTrackerProps {
  children?: ReactNode;
  title: string;
  description?: string;
}

export const Layout = (props: LayoutProps) => (
  <SectionContextProvider>
    <SEO title={props.title} />
    <div className={css.container}>
      <Header />
      {props.sectionTitles && (
        <SectionTracker sectionTitles={props.sectionTitles} />
      )}
      <main id="mainContent" className={css.content}>
        {props.children}
      </main>
      <Footer />
    </div>
  </SectionContextProvider>
);
